<template>
  <section class="mt-5" v-if="hasOngoingTransactions">
    <div
      class="flex justify-between count py-2.5 items-center cursor-pointer lg:pl-4 w-11/12 mb-6 lg:w-3/4 mx-auto border rounded-lg gap-x-3 lg:gap-x-8"
    >
      <div class="text pl-3 flex gap-x-3 items-center">
        <timer />
        <p class="text-sm font-normal">
          Ongoing Transfer -
          <span class="font-bold">{{ counts.totalCount }}</span>
        </p>
      </div>
      <div
        class="text text-md font-normal flex justify-end pl-5 lg:pl-12 float-right gap-x-1.5 items-center"
      >
        <p>View all</p>
        <span class="font-bold text-lg"> > </span>
      </div>
      <div></div>
    </div>
  </section>
</template>

<script>
export default {
  components: {
    Timer: () => import('@/assets/v2/icons/Timer.vue')
  },
  computed: {
    hasStatusProcessing () {
      return this.transactionDetails.status === this.$STATUS.PROCESSING
    },
    transactionInfo () {
      return this.$store.state.transactions.transactions
    },
    counts () {
      return this.transactionInfo.page
    },
    transactionItems () {
      return this.$store.state.transactions.transactions.items || []
    },
    hasOngoingTransactions () {
      return this.transactionItems.some(
        (items) =>
          items.status === this.$STATUS.PENDING ||
          items.status === this.$STATUS.PROCESSING
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.count {
  background-color: #fff8eb;
  display: flex;
  justify-content: space-between;
}
.text {
  color: #d69e2e;
}
</style>
